import React from "react";

const ReportIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M1.5 9.9375C1.5 9.42 1.92 9 2.4375 9H4.3125C4.83 9 5.25 9.42 5.25 9.9375V15.5625C5.25 16.08 4.83 16.5 4.3125 16.5H2.4375C2.18886 16.5 1.9504 16.4012 1.77459 16.2254C1.59877 16.0496 1.5 15.8111 1.5 15.5625V9.9375ZM7.125 6.1875C7.125 5.67 7.545 5.25 8.0625 5.25H9.9375C10.455 5.25 10.875 5.67 10.875 6.1875V15.5625C10.875 16.08 10.455 16.5 9.9375 16.5H8.0625C7.81386 16.5 7.5754 16.4012 7.39959 16.2254C7.22377 16.0496 7.125 15.8111 7.125 15.5625V6.1875ZM12.75 2.4375C12.75 1.92 13.17 1.5 13.6875 1.5H15.5625C16.08 1.5 16.5 1.92 16.5 2.4375V15.5625C16.5 16.08 16.08 16.5 15.5625 16.5H13.6875C13.4389 16.5 13.2004 16.4012 13.0246 16.2254C12.8488 16.0496 12.75 15.8111 12.75 15.5625V2.4375Z"
      stroke="#757373"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ReportIconSvg;
